import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=547141fd&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=547141fd&prod&lang=less&scoped=true"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=547141fd&prod&lang=less"
import style2 from "./orderDetails.vue?vue&type=style&index=2&id=547141fd&prod&lang=less"
import style3 from "./orderDetails.vue?vue&type=style&index=3&id=547141fd&prod&lang=less"
import style4 from "./orderDetails.vue?vue&type=style&index=4&id=547141fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547141fd",
  null
  
)

export default component.exports